import { List } from '../List'
import { CommonWork } from '../CommonWork'

export class NirAccomplishmentParent extends List {
  constructor(obj) {
    super(NirAccomplishment, obj)
  }
}

export class NirAccomplishment {
  constructor(obj) {
    this.id = obj?.id || null
    this.commonWork = new CommonWork(obj?.commonWork || null)
    this.scientificHeadName = obj?.scientificHeadName || null
    this.speciality = obj?.speciality || null
    this.executionTerm = obj?.executionTerm || null
    this.nirType = obj?.nirType || null
    this.printedWork = obj?.printedWork || null
  }

  getForAPI() {
    return {
      id: this.id,
      commonWork: this.commonWork.getForAPI(),
      scientificHeadName: this.scientificHeadName,
      speciality: this.speciality,
      executionTerm: this.executionTerm,
      nirType: this.nirType,
      printedWork: this.printedWork
    }
  }
}
